// -------------- DASHBOARD Page --------------
export const DASHBOARD_FIELD_ERROR       = 'DASHBOARD_FIELD_ERROR';
export const DASHBOARD_FIELD_RESET_ERROR = 'DASHBOARD_FIELD_RESET_ERROR';
export const DASHBOARD_GET_ITEM          = 'DASHBOARD_GET_ITEM';
export const DASHBOARD_SET_ITEM          = 'DASHBOARD_SET_ITEM';
export const DASHBOARD_GET_NOTE          = 'DASHBOARD_GET_NOTE';



// --------- DASHBOARD Page ---------
export function dashboardFieldError(field, fieldData = {}) {
    return { type: DASHBOARD_FIELD_ERROR, fieldName: field, fieldData: fieldData }
}
export function dashboardFieldResetError(field, fieldData = {}) {
    return { type: DASHBOARD_FIELD_RESET_ERROR }
}
export function dashboardSetItem(targetItem) {
    return { type: DASHBOARD_SET_ITEM, data: targetItem }
}
export function dashboardGetItem(targetItem) {
    return { type: DASHBOARD_GET_ITEM, data: targetItem }
}
export function dashboardGetNote(targetItem) {
    return { type: DASHBOARD_GET_NOTE, data: targetItem }
}

